export const mapObjectValues = <K extends keyof never, V, T>(
  obj: Record<K, V>,
  mapper: (objValue: V) => T,
): Record<K, T> => {
  return Object.keys(obj).reduce<Record<K, T>>((mappedObject: Record<K, T>, key) => {
    mappedObject[key as K] = mapper(obj[key as K]);

    return mappedObject;
  }, {} as Record<K, T>);
};
